var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-container-style"},[_c('MyQuotaInquiryList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }